/** @format */

import React, { useContext, useState } from "react";
import { Modal, Alert, Input, message, Spin } from "antd";
import VoiceGainAuthSvcApi from "../../../apis/VoiceGainAuthSvcApi";
import { AccountsOverviewContainerContext } from "./AccountsOverview.container";
import { DeleteOutlined } from "@ant-design/icons";

interface IAccountsOverviewDeleteAccountModalProps {
	account: string;
	accountId: string;
}

const AccountsOverviewDeleteAccountModal: React.FC<
	IAccountsOverviewDeleteAccountModalProps
> = ({ account, accountId }) => {
	const accountsOverviewContainerContext = useContext(
		AccountsOverviewContainerContext
	);
	const [isDeleteModalVisible, setIsDeleteModalVisible] =
		useState<boolean>(false);
	const [accountSelectedForDeletion, setAccountSelectedForDeletion] =
		useState<string>("");
	const [deleteConfirmationInput, setDeleteConfirmationInput] =
		useState<string>("");
	const [disableDeleteBtn, setDisableDeleteBtn] = useState<boolean>(true);
	const [isPendingDelete, setIsPendingDelete] = useState<boolean>(false);

	//Modal controls for deleting account
	const showDeleteModal = (user: string) => {
		setIsDeleteModalVisible(true);
		setAccountSelectedForDeletion(user);
	};

	const handleDeleteModalOk = () => {
		setIsPendingDelete(true);
		VoiceGainAuthSvcApi.deleteAccount(accountId).then((response) => {
			if (response.ok) {
				setIsDeleteModalVisible(false);
				setDisableDeleteBtn(true);
				setDeleteConfirmationInput("");
				message.success("Account deleted successfully.");
				setIsPendingDelete(false);
				if (accountsOverviewContainerContext.mutateAccounts)
					accountsOverviewContainerContext.mutateAccounts();
			} else {
				setDisableDeleteBtn(true);
				setDeleteConfirmationInput("");
				message.error("Error deleting account.");
				setIsPendingDelete(false);
			}
		});
	};

	const handleDeleteModalCancel = () => {
		setIsDeleteModalVisible(false);
		setDeleteConfirmationInput("");
	};

	const handleOnChangeDeleteModalInput = (e) => {
		setDeleteConfirmationInput(e.target.value);
		if (e.target.value === "DELETE") setDisableDeleteBtn(false);
		else if (e.target.value !== "DELETE") setDisableDeleteBtn(true);
	};

	return (
		<div>
			<div onClick={() => showDeleteModal(account)}>
				<DeleteOutlined style={{ marginRight: "0.2rem" }} />
				Delete
			</div>
			<Modal
				title="Delete Account"
				open={isDeleteModalVisible}
				onOk={handleDeleteModalOk}
				onCancel={handleDeleteModalCancel}
				okType={"danger"}
				okText={"Delete"}
				cancelText={"Close"}
				okButtonProps={{
					disabled: disableDeleteBtn,
				}}>
				<Spin spinning={isPendingDelete}>
					<Alert
						message={`WARNING: `}
						description={
							<div>
								You are about to delete{" "}
								<span className="bold-underline-text">
									{accountSelectedForDeletion}
								</span>
								. Please type{" "}
								<span className="bold-underline-text">DELETE</span> in the text
								area below and press delete to confirm deletion of account.
							</div>
						}
						type="warning"
						showIcon
					/>
					<Input
						id="delete-input"
						onChange={handleOnChangeDeleteModalInput}
						value={deleteConfirmationInput}
					/>
				</Spin>
			</Modal>
		</div>
	);
};

export default AccountsOverviewDeleteAccountModal;
